import angular from 'angular';
import 'promise-polyfill/src/polyfill';
require("jspolyfill-array.prototype.find");
import 'array-flat-polyfill';
import { registerApiFactory } from '../api/api-factory';
import alertify from '../res/lib/alertifyjs/alertify.min.js';

var cloudConnect = angular.module('cloudConnect', []);

registerApiFactory(cloudConnect);

cloudConnect.controller('CloudConnectController', ['$rootScope', '$scope', 'ApiFactory', function($rootScope, $scope, ApiFactory) {
    
    $scope.init = function () {
        $scope.haveShownGroupNotice = false
        $scope.submitting = false
        $scope.scrapeUri()
        $scope.fetchAgencyData()
        $scope.fetchInviteData()
        $rootScope.lastAccountLoadTime = new Date().getTime();
    }

    $scope.credentialIsExpired = (credential) => {
        return credential.hasAlertedAboutExpiredCredentials
    }

    $scope.scrapeUri = function() {
    
        $scope.agencyId = window.location.pathname.split('/')[2]
        $scope.inviteId = window.location.pathname.split('/')[3]
    
    }

    $scope.boboConsent = { available: false, checked: true };

    $scope.whiteLabelStyle = {
        favicon: "/cloud-connect/images/CloudConnectFavicon.png",
        logo: "",
        buttonStyle: {},
        neutralButtonStyle:{},
        companyName: "",
        set: false
    }

    $scope.fetchWhiteLabelInfo = async () => {
        try {
            const response = await ApiFactory.get(`/rest/wl/info?subdomain=${$scope.agency.whiteLabelSubdomain}`);
            $scope.setWhiteLabelStyle(response.data);
        } catch (error) {
            console.error('Error fetching white label info:', error);
        }
    }

    $scope.setFavicon = function() {

        const favicons = document.getElementsByClassName("favicon")

        for (let i = 0; i < favicons.length; i++) {

            favicons[i].href = $scope.whiteLabelStyle.favicon

        }

    }

    $scope.setWhiteLabelStyle = function(info) {

        if (info.whiteLabel != null){
            if (info.whiteLabel["favicon"] && info.whiteLabel["favicon"].length > 0) {
                $scope.whiteLabelStyle.favicon = info.whiteLabel["favicon"]
            }

            $scope.setFavicon()

            if (info.whiteLabel["logo"] && info.whiteLabel["logo"].length > 0) {
                $scope.whiteLabelStyle.logo = info.whiteLabel["logo"];
            }
            
            if (info.whiteLabel["companyName"] && info.whiteLabel["companyName"].length > 0){
                $scope.whiteLabelStyle.companyName = info.whiteLabel["companyName"]
                $scope.whiteLabelStyle.set = true
            }

            $scope.whiteLabelStyle.buttonStyle = info.whiteLabel["buttonStyle"]

            $scope.whiteLabelStyle.neutralButtonStyle = info.whiteLabel["neutralButtonStyle"]
    
        }

        $scope.$apply()

    }

    /** ** GENERIC API METHODS *** */

	$scope.getRequest = function(url, callback, errorCallback) {
		ApiFactory.get(url)
			.then(function(response) {
				callback(response.data);
			})
			.catch(function(error) {
				errorCallback(error);
			});
	};

	$scope.getRequestWithParam = function(url, param, callback, errorCallback) {
		ApiFactory.get(url)
			.then(function(response) {
				callback(param, response.data);
			})
			.catch(function(error) {
				errorCallback(param, error);
			});
	};

	$scope.postRequest = function(url, requestData, callback, errorCallback) {
		ApiFactory.post(url, requestData)
			.then(function(response) {
				callback(response.data);
			})
			.catch(function(error) {
				errorCallback(error);
			});
	};

    // Is Undefined
	$scope.isUndefined = function(foo) {
		return (foo == undefined);
	}

    $scope.isDefined = function(foo) {
		return !$scope.isUndefined(foo);
	}
	
    // Is Empty
	$scope.isEmpty = function(foo) {
		return $scope.isUndefined(foo) || foo.length == 0;
	}

    // Generic Alert
	$scope.genericAlert = function(title, message) {

		// If it's a json response, extract the data
		if (!$scope.isUndefined(message.data)) {
			message = message.data;
		}
		// message = String(message).replace(/\n/g, "<br/>");
		alertify.alert(`<h2> ${title} </h2>`, `<br/><p> ${message} <br/></p>`);
	}
    
    $scope.agency = {
        companyName: "An agency"
    }

    $rootScope.checkForNewAccounts = function()
    {
        $scope.fetchInviteData()
    }

    $scope.checkForNewAccountsCallback = function(data)
    {
        if(data.error) {
            console.log("Failed to check for new accounts. Error: " + data.errorReason);
            return;
        }

        $rootScope.lastAccountLoadTime = new Date().getTime();

        angular.forEach(data.platformCredentials.platformCredentials, function(account) {
            $scope.addCredential(account.platformType, account);
        });
    }

    $scope.checkForNewAccountsErrorCallback = function(error)
    {
        console.log("Failed to check for new accounts.", error);
    }


    $scope.fetchAgencyData = function() {
        ApiFactory.get(`/rest/agency/public/${$scope.agencyId}`)
            .then(function (response) {
                $scope.setAgency(response.data);
            })
            .catch(function (error) {
                console.error('Failed to fetch agency data', error);
            });
    };
        
    $scope.setAgency = function(data) {

        $scope.agency = data
        if ($scope.agency.isWhiteLabeled === 'true') {
            $scope.fetchWhiteLabelInfo()
        } else {
            $scope.whiteLabelStyle.favicon = "/res/cc_favicon.png"
            $scope.setFavicon()
            $scope.whiteLabelStyle.set = true
        }
        
        $scope.$apply()

    }

    $scope.fetchInviteData = function() {
        ApiFactory.get(`/rest/cloudconnect/${$scope.agencyId}/${$scope.inviteId}`)
            .then(function (response) {
                $scope.setInvite(response.data);
            })
            .catch(function (error) {
                console.error('Failed to fetch invite data', error);
            });
    };

    $scope.setInvite = function(data) {
        $scope.invite = data
        $scope.boboConsent.available = data.boboConsentAvailable === true;
        $scope.boboConsent.checked = $scope.boboConsent.available;
        $scope.setCredentials()
        $scope.platforms.forEach(platform => {
            if (platform.credentials.length === 0) {
                platform.showCredentials = false
            }
        })

        if ($scope.invite.hiddenSocialPlatforms) {
            const hiddenPlatformsSet = new Set($scope.invite.hiddenSocialPlatforms);
            $scope.platforms = $scope.platforms.filter(platform => !hiddenPlatformsSet.has(platform.type));
        }

        $scope.submitting = false;
    }

    $scope.onBoboConsentChange = function() {
        if ($scope.boboConsent.checked) {
            return;
        }
        alertify.set({ labels: { ok: "Yes, disable", cancel: "Cancel" }, buttonReverse: false, buttonFocus: "cancel" });
        alertify.confirm(
            "<h2>Disable long-lived tokens?</h2><br/><p>By disabling this feature, you will be required to relink your accounts every 60 days.</p>",
            function(confirmed) {
                if (!confirmed) {
                    $scope.$apply(function() { $scope.boboConsent.checked = true; });
                }
            }
        );
    };

    $scope.platforms = [
        {
            type: 'FACEBOOK',
            name: "Facebook", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/facebook-icon.svg",
            authUrl: `rest/platform/preauth/FACEBOOK`,
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            supportsRelinking: true,
            relinkUrl: `rest/platform/relink/preauth/FACEBOOK`
        },
        {
            type: 'INSTAGRAM',
            name: "Instagram", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/instagram-icon.svg",
            authUrl: `rest/platform/preauth/INSTAGRAM`,
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            supportsRelinking: true,
            relinkUrl: `rest/platform/relink/preauth/INSTAGRAM`
        },
        {
            type: 'THREADS',
            name: "Threads",
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/threads-icon.svg",
            authUrl: 'rest/platform/preauth/THREADS',
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            relinkUrl: 'rest/platform/preauth/THREADS',
            supportsRelinking: true
        },
        {
            type: 'LINKEDIN',
            name: "LinkedIn", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/linkedin-icon.svg", 
            authUrl: `rest/platform/preauth/LINKEDIN`,
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            supportsRelinking: true,
            relinkUrl: `rest/platform/relink/preauth/LINKEDIN`
        },
        {
            type: 'PINTEREST',
            name: "Pinterest", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/pinterest-logo.svg", 
            authUrl: 'rest/platform/preauth/PINTEREST',
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            relinkUrl: 'rest/platform/preauth/PINTEREST',
            supportsRelinking: true
        },
        {
            type: 'YOUTUBE',
            name: "YouTube", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/youtube-icon.svg", 
            authUrl: 'rest/platform/preauth/YOUTUBE',
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            relinkUrl: 'rest/platform/preauth/YOUTUBE',
            supportsRelinking: true
        },
        {
            type: 'GMB',
            name: "GMB", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/google-my-business-logo.svg",
            authUrl: 'rest/platform/preauth/GMB',
            useCode: false,
            multiAccounts: true,
            redirectUrl: "/cloudconnect/authenticate/gmb",
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            relinkUrl: 'rest/platform/preauth/GMB',
            supportsRelinking: true
        },
		{
			type: 'TIKTOK',
            name: "TikTok", 
            platformImgUrl: "https://pcore-customer-media.s3.amazonaws.com/app/static/tiktok-logo-new.svg",
            authUrl: 'rest/platform/preauth/TIKTOK',
            useCode: false,
            linkAppCallback: $rootScope.checkForNewAccounts,
            credentials: [],
            showCredentials: false,
            relinkUrl: 'rest/platform/preauth/TIKTOK',
            supportsRelinking: true
		}
    ];

    $scope.toggleShowCredentials = function(platform) {
        platform.showCredentials = !platform.showCredentials
        $scope.$apply()
    }
    
    $scope.linkApp = function(platform)
    {
        var appType = platform.type;
        $scope.platformLinkName = platform.name;

        $rootScope.loadingAppAuthorizationLink = true;
        $rootScope.authorizeAppPopupBlocked = false;
        $rootScope.authorzingApp = false;
        $rootScope.authorizeAppLink = undefined;
        $rootScope.authorizeAppError = undefined;
        $rootScope.linkAppCode = "";

        const path = `/${platform.authUrl}?cloudconnect=true&id=${$scope.inviteId}&ag=${$scope.agencyId}&brand=${$scope.invite.workspaceId}`;
        $scope.getRequestWithParam(path, platform, $scope.linkAppCallback, $scope.linkAppErrorCallback);
    }

    $scope.displayLink = function (url, platform, relink) {
      alertify
        .alert(
          `<h2></h2>`,
          `<br/><a style="font-size: 24px; text-decoration: underline;" href=${url} target="_blank">Click here to link your ${$scope.platformLinkName} account<a/><br/>`,
          function () {
            if (relink) {
                $scope.fetchInviteData();
            } else {
                platform.linkAppCallback();
            }
          }
        )
        .set("label", "Done")
        .set("closable", false);
    };
    
    $scope.linkAppCallback = function(platform, data)
    {
        $rootScope.loadingAppAuthorizationLink = false;
        $rootScope.authorizeAppPopupBlocked = false;

        if($scope.isEmpty(data.url))
        {
            console.log("pre-auth URL was empty");
            return;
        }

        $rootScope.authorizeAppLink = data.url;
        $rootScope.stateId = data.url.split('state=')[1];

        $scope.displayLink(data.url, platform, false);
    }

    $scope.linkAppErrorCallback = function(platform, error)
    {
        $rootScope.loadingAppAuthorizationLink = false;
        const reason = error?.message || '';
        if (reason === 'OVER_USAGE_LIMIT') {
            $scope.genericAlert(
                "Account Limit Reached",
                "You've maxed out your social media accounts in this workspace. Please contact your system admin if you believe this is incorrect.",
            );
            return;
        }
        console.log(`Failed to generate ${platform.name} preauth URL`, error);
        $scope.genericAlert("Failed to Generate Link", "There was an issue getting an authorization link from the provider.");
    }

    $scope.relinkApp = function(platform) {
        var appType = platform.type;
        $scope.platformLinkName = platform.name;
    
        $rootScope.loadingAppAuthorizationLink = true;
        $rootScope.authorizeAppPopupBlocked = false;
        $rootScope.authorzingApp = false;
        $rootScope.authorizeAppLink = undefined;
        $rootScope.authorizeAppError = undefined;
        $rootScope.linkAppCode = "";

        const path = `/${platform.relinkUrl}?cloudconnect=true&id=${$scope.inviteId}&ag=${$scope.agencyId}&brand=${$scope.invite.workspaceId}`;
        $scope.getRequest(path, $scope.relinkAppCallback, $scope.relinkAppErrorCallback);
    }

    $scope.relinkAppCallback = function(data) {
        $rootScope.loadingAppAuthorizationLink = false;
        $rootScope.authorizeAppPopupBlocked = false;

        if($scope.isEmpty(data.url))
        {
            console.log("pre-auth URL was empty");
            return;
        }

        $rootScope.authorizeAppLink = data.url;
        $rootScope.stateId = data.url.split('state=')[1];

        $scope.displayLink(data.url, null, true);
    }

    $scope.relinkAppErrorCallback = function(error) {
        $rootScope.loadingAppAuthorizationLink = false;
        console.log('Error relinking app', error);
        $scope.genericAlert("Failed to Relink Account", "We ran into an issue relinking your account.");
    }

    /* AUTHORIZE */
	$rootScope.authorize = function(platform, pin)
	{
		var platformType = platform.type;
		
		if($scope.isEmpty(pin)) {
			 $rootScope.authorizeAppError = "You must provide a valid code.";
			 return;
		 }
		
		if(platform.multiAccounts) {
			
			$rootScope.choosePages = true;
			
			// redirect the user to the add-account page

			var choosePagesLink = platform.redirectUrl + "?code=" + pin + "&state=" + $rootScope.stateId;
			var newWindow = window.open(choosePagesLink);
			
			if(!newWindow || newWindow.closed || typeof newWindow.closed=='undefined') 
			{ 
			     // POPUP BLOCKED
				$rootScope.choosePagesLink = choosePagesLink;
			}
			else
			{	 
				// reload integrations on new window close
					 
				var timer = setInterval(function() { 
						    if(newWindow.closed) {
						        clearInterval(timer);
						        platform.linkAppCallback();
								$rootScope.minimizeAppContainer(platform.type);
						    }
					 }, 1000);
			}
			
			return;
		}
		
		$rootScope.authorizingApp = true;
		
		var request = {};
		request.platformType = platformType.toUpperCase();
		request.pin = pin;
        request.stateId = $rootScope.stateId;
		$scope.postRequest("/rest/platform/authorize", request, $scope.authorizeCallback, $scope.authorizeErrorCallback);
	}
	
	/* AUTHORIZE CALLBACK */
	$scope.authorizeCallback = function()
	{
		$rootScope.authorizingApp = false;
				
        // go back to the picking window
        $scope.authorizingPlatform = false;

        $scope.fetchInviteData();
	}
	
	/* AUTHORIZE ERROR CALLBACK */
	$scope.authorizeErrorCallback = function(error)
	{
		$rootScope.authorizingApp = false;
		$rootScope.addEmailButton = "Add Email";
		
		$rootScope.authorizeAppError = error?.message || "Authorizing the account failed.";
		console.log('Authorizing account failed', error);
		$rootScope.authorizePlatformErrorText = "Authorizing account failed";
	}
    
    $scope.setCredentials = () => {
        $scope.platforms.forEach(platform => platform.credentials = []);

        if ($scope.invite.platformCredentials) {
            $scope.invite.platformCredentials.platformCredentials.forEach(credential => $scope.addCredential(credential));
        }
        
        const setCredentialsCallback = function(resp) {
            $scope.calculateCredentials(resp.enrolledCredentialsLimit, resp.enrolledCredentialsCount)
            $scope.workspaceName = resp.workspaceName
            $scope.$apply()
        }

        ApiFactory.get(`/rest/workspaces/public/${$scope.invite.workspaceId}`)
            .then(function (response) {
                setCredentialsCallback(response.data);
            })
            .catch(function (error) {
                console.error('Failed to fetch workspace credentials', error);
            });
    };

    $scope.calculateCredentials = function(accountLimitFromBackend, totalFromBackend) {

        const arrOfAllCredentials = $scope.platforms.map(platform => platform.credentials).flat()
        let unenrolledCredentialsTotal = 0
        let enrolledCredentialsTotal = 0

        arrOfAllCredentials.forEach((credential) => {
            if (credential.enrolled) {
                enrolledCredentialsTotal = enrolledCredentialsTotal + 1
            } else {
                unenrolledCredentialsTotal = unenrolledCredentialsTotal + 1 
            }
        })

        $scope.credentialsCounts = {
            totalCredentials: unenrolledCredentialsTotal + totalFromBackend,
            credentialsLimit: accountLimitFromBackend,
            unenrolledCredentialsTotal: unenrolledCredentialsTotal,
            enrolledCredentialsTotal: totalFromBackend
        }


        if ($scope.credentialsCounts.totalCredentials > $scope.credentialsCounts.credentialsLimit) {
            $scope.overLimit = true
        }
        else {
            $scope.overLimit = false
        }
        
        $scope.$apply()
    }

    $scope.addCredential = function(credential) {
        const platform = $scope.platforms.find(platform => platform.type === credential.platformType);
    
        if (!platform) {
            return;
        }
    
        platform.credentials.push(credential);

        if ((credential.platformType === 'FACEBOOK' && credential.group) && !credential['isGroupAuthorized']) {
            $scope.checkIfGroupIsAuthorized(credential)
        }
    };

    $scope.checkIfGroupIsAuthorized = function(credential) {
        const url = `/rest/cloudconnect/facebook/group/${$scope.agencyId}/${$scope.inviteId}/${$scope.invite.workspaceId}/${credential.absoluteId}`;

        ApiFactory.get(url)
            .then(function (response) {
                var data = response.data;
                if (!data.isAuthorized) {
                    $scope.platforms.find(platform => platform.type === 'FACEBOOK').showCredentials = true;
                    credential.showAddApp = true;

                    if (!$scope.haveShownGroupNotice) {
                        $scope.haveShownGroupNotice = true;
                        $scope.showAuthorizeGroupNotice();
                    }
                }
                if (data.isAuthorized) {
                    credential.showAddApp = false;
                }
            })
            .catch(function (error) {
                console.error('Failed to check group authorization', error);
            });
    };

    $scope.removeCredential = function(credential) {
        const url = `/rest/cloudconnect/${$scope.agencyId}/${$scope.inviteId}/${credential.accountId}`;

        ApiFactory.delete(url)
            .then(function (response) {
                $scope.setInvite(response.data);
            })
            .catch(function (error) {
                console.error('Failed to remove credential', error);
            });
    };

    // Submit credentials and persist in Customer table
    $scope.submit = function() {
        var request = {};
        request.inviteId = $scope.inviteId;
        request.agencyId = $scope.agencyId;
        if ($scope.boboConsent.available) {
            request.boboConsent = $scope.boboConsent.checked;
        }
        $scope.submitting = true;
        $scope.postRequest("/rest/cloudconnect/submit", request, $scope.submitCallback, $scope.submitErrorCallback)
    }

    $scope.submitCallback = function() {
        $scope.genericAlert("Success!", `${$scope.credentialsCounts.unenrolledCredentialsTotal ? $scope.credentialsCounts.unenrolledCredentialsTotal : 0} ${$scope.credentialsCounts.unenrolledCredentialsTotal === 1 ? 'account' : 'accounts'} added.`);
        $scope.fetchInviteData();
    }

    $scope.submitErrorCallback = function(error) {
        console.log(error);
        $scope.submitting = false;
        $scope.genericAlert("Failed to Add Accounts", "If this problem persists, please contact us.");
    }

    $scope.showPrivacyPolicy = function()
	{
        alertify.minimalDialog || alertify.dialog('minimalDialog',function(){
            return {
                main:function(content){
                    this.set({title: "Privacy Policy"})
                    this.setContent(content)
                    this.set("maximizable", false)
                }
            };
        });
        alertify.minimalDialog("<p>We use the data and permissions you give us to make it possible for us to post on your behalf, and to monitor the performance of posts on your account.<br/><br/>  We do so in a manner that is consistent with the terms of service of each platform (Facebook, Instagram, Twitter, YouTube, Google Business Profile, LinkedIn, and Pinterest).<br/><br/>We don’t give away or sell your personal data.<br/><br/>You can always revoke the permissions you give us from each platform's integrations page.<br/><br/>For any further questions about our privacy policy please contact the representative who sent you this link. </p>").maximize();
	}

    $scope.showAuthorizeGroupNotice = function() {
        const title = '<h2>Please add the facebook group app!</h2>'
        const message = "<br/> To finish linking facebook groups, we need you to add the Cloud Campaign Facebook Group App on each group you link. <br></br> Please do so now by clicking on the add app button next to the group name, and then search for Cloud Campaign and add the app to your group."

        alertify.alert(title, message)
    }

    $scope.authorizeGroup = function(account) {

		var newWindow = window.open(account.groupPrompt);
		 
		 if(!newWindow || newWindow.closed || typeof newWindow.closed=='undefined') 
		 { 
		     // POPUP BLOCKED
			 console.error("Group authorization window was blocked.");
		 }
		 else
		 {	 
			 // Check if the group was authorized on window close
			 var timer = setInterval(function() { 
				 if(newWindow.closed) {
					 clearInterval(timer);
					 $scope.checkIfGroupIsAuthorized(account);
				 }
			 }, 1000);
		}
	}
}]);

export default cloudConnect;
